import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import LineItemTypeStep from '../../LineItemTypeStep'
import DatesStep from '../../DatesStep'
import InventoryTargetingStep from './InventoryTargetingStep'

import { isAdInventoryTargetingEnabled } from '../../../formatters/formatInventoryTargeting'

import { rightSelector } from '../../../../../../../../modules/selectors/rights'

export const usePercentageAllocationSteps = onValidationChange => {
  const right = useSelector(rightSelector)

  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)

  return useMemo(
    () => [
      {
        component: <LineItemTypeStep />,
        show: true
      },
      {
        component: <InventoryTargetingStep onValidationChange={onValidationChange} />,
        show: adInventoryTargetingEnabled
      },
      {
        component: <DatesStep onValidationChange={onValidationChange} />,
        show: true
      }
    ],
    [adInventoryTargetingEnabled, onValidationChange]
  )
}
